export const copyToClipBoard = textToCopy => {
	navigator.clipboard.writeText(textToCopy);
};
